module.exports = __webpack_public_path__ + "img/img_shenqingbiao.5df032ce.jpg";